export { IconSmall2 } from "./IconSmall2";
